import React, { useContext } from "react";
import { PictureSetsContext } from "../providers/PictureSetsProvider";

export const usePictureSets = () => {
  const context = useContext(PictureSetsContext);
  if (!context) {
    throw new Error(
      "usePictureSets must be used within a PictureSetsProvider",
    );
  }
  return context;
};
